import { render, staticRenderFns } from "./AdminExpiryTerm.vue?vue&type=template&id=5c2e4c32&"
import script from "./AdminExpiryTerm.vue?vue&type=script&lang=ts&"
export * from "./AdminExpiryTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports